var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content pb-0" },
    [
      _c(
        "Titlebar",
        {
          attrs: {
            incrustation: "fa-bullhorn",
            backPath: { name: "RemoteMonitoringList" },
          },
        },
        [_c("h1", [_vm._v(_vm._s(_vm.$t("remoteMonitoring.titles.log")))])]
      ),
      _vm._v(" "),
      _c(
        "UiCard",
        [
          _c(
            "Btn",
            {
              staticClass: "secondary no-hover filters mb-3",
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.toggleFilters($event)
                },
              },
            },
            [
              _c("i", { staticClass: "fa fa-filter" }),
              _vm._v("   " + _vm._s(_vm.$t("global.filters")) + "   "),
              _c("i", { staticClass: "fa fa-caret-down" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "on-clickaway",
                      rawName: "v-on-clickaway",
                      value: _vm.closeFilters,
                      expression: "closeFilters",
                    },
                  ],
                  staticClass: "button-actions up",
                  class: { show: _vm.showFilters },
                  attrs: { slot: "actions" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                  slot: "actions",
                },
                [
                  _c(
                    "form",
                    { staticClass: "p-4", staticStyle: { width: "300px" } },
                    [
                      _c("div", { staticClass: "form-row row" }, [
                        _c("label", { staticClass: "col-4" }, [
                          _vm._v(
                            _vm._s(_vm.$t("remoteMonitoring.filters.type"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filters.type,
                                expression: "filters.type",
                              },
                            ],
                            staticClass: "form-input col-8",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.filters,
                                  "type",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c("option"),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "1" } }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("remoteMonitoring.filters.types.1")
                                  ) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "2" } }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("remoteMonitoring.filters.types.2")
                                  ) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "3" } }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("remoteMonitoring.filters.types.3")
                                  ) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "4" } }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("remoteMonitoring.filters.types.4")
                                  ) +
                                  "\n              "
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row row" }, [
                        _c("label", { staticClass: "col-4" }, [
                          _vm._v(
                            _vm._s(_vm.$t("remoteMonitoring.filters.state"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filters.state,
                                expression: "filters.state",
                              },
                            ],
                            staticClass: "form-input col-8",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.filters,
                                  "state",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c("option"),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "1" } }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("remoteMonitoring.filters.states.1")
                                  ) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "0" } }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("remoteMonitoring.filters.states.0")
                                  ) +
                                  "\n              "
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row row" }, [
                        _c("label", { staticClass: "col-4" }, [
                          _vm._v(
                            _vm._s(_vm.$t("remoteMonitoring.filters.dati"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filters.device,
                                expression: "filters.device",
                              },
                            ],
                            staticClass: "form-input col-8",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.filters,
                                  "device",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c("option"),
                            _vm._v(" "),
                            _vm._l(_vm.devices, function (device) {
                              return _c(
                                "option",
                                {
                                  key: device.id,
                                  domProps: { value: device.id },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(device.name) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row row" }, [
                        _c("label", { staticClass: "col-4" }, [
                          _vm._v(
                            _vm._s(_vm.$t("remoteMonitoring.filters.user"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterUser,
                              expression: "filterUser",
                            },
                          ],
                          staticClass: "form-input col-8",
                          attrs: { type: "text" },
                          domProps: { value: _vm.filterUser },
                          on: {
                            keyup: _vm.debounceFilter,
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.filterUser = $event.target.value
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-row row",
                          staticStyle: { "margin-bottom": "0" },
                        },
                        [
                          _c("label", { staticClass: "col-4" }, [
                            _vm._v(
                              _vm._s(_vm.$t("remoteMonitoring.filters.date"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "inputmask",
                                rawName: "v-inputmask",
                                value: "99/99/9999",
                                expression: "'99/99/9999'",
                              },
                              {
                                name: "model",
                                rawName: "v-model.lazy",
                                value: _vm.filters.date,
                                expression: "filters.date",
                                modifiers: { lazy: true },
                              },
                            ],
                            staticClass: "form-input col-8",
                            attrs: { type: "text" },
                            domProps: { value: _vm.filters.date },
                            on: {
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.filters,
                                  "date",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          this.isLoading
            ? _c("div", { staticClass: "p-3" }, [_c("UiSpinner")], 1)
            : _vm._e(),
          _vm._v(" "),
          !this.isLoading
            ? _c("div", { staticClass: "table-container" }, [
                !!_vm.tableData.length
                  ? _c(
                      "table",
                      { staticClass: "table" },
                      _vm._l(_vm.tableData, function (row) {
                        return _c("tr", { staticClass: "w-100" }, [
                          _c("td", { staticClass: "p-1" }, [
                            _c(
                              "span",
                              {
                                staticClass: "icon-circle",
                                class: {
                                  "state-ok": row.status == 1,
                                  "state-ko": row.status == 0,
                                  "state-pending": row.status == 2,
                                },
                              },
                              [_c("i", { class: _vm.getTypeIcon(row.type) })]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticStyle: { width: "calc(100% - 200px)" } },
                            [
                              _c("span", { staticClass: "description" }, [
                                _vm._v(_vm._s(row.payload)),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("td", [
                            row.user != ""
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.$t("by")) + " "),
                                  _c("strong", [_vm._v(_vm._s(row.user))]),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("span", [
                              _c("strong", [
                                _vm._v(_vm._s(_vm._f("only_date")(row.sentAt))),
                              ]),
                              _vm._v(
                                " " + _vm._s(_vm.$t("at")) + "\n              "
                              ),
                              _c("strong", [
                                _vm._v(_vm._s(_vm._f("only_time")(row.sentAt))),
                              ]),
                            ]),
                          ]),
                        ])
                      }),
                      0
                    )
                  : _c("div", { staticClass: "text-center" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("global.no_results")) +
                          "\n      "
                      ),
                    ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("Pagination", {
                ref: "pagination",
                class: "reverse",
                on: { change: _vm.handlePagination },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }